import { parseDomain, ParseResultType } from 'parse-domain'

export default () => {
	const hostname = window.location.hostname
	const parseResult = parseDomain(hostname)

	switch (parseResult.type) {
		case ParseResultType.Listed: {
			const { subDomains, domain, topLevelDomains } = parseResult
			return {
				subdomain: subDomains.join('.'),
				domain: domain,
				tld: topLevelDomains[0],
			}
		}
		case ParseResultType.Reserved:
		case ParseResultType.NotListed: {
			const { hostname } = parseResult
			if (import.meta.env.NODE_ENV === 'production') {
				throw new Error(`${hostname} is an ip address or invalid domain`)
			} else {
				return {
					subdomain:
						parseResult.labels.length === 4
							? parseResult.labels.slice(0, 2).join('.')
							: parseResult.labels[0],
					domain: hostname,
					tld: parseResult.labels[parseResult.labels.length - 1],
				}
			}
		}
		default:
			throw new Error(`${hostname} is not a valid domain`)
			return undefined
	}
}
